import { mediaQueryLarge, isMobileBreakpoint } from "@theme/utilities";

class AccordionCustom extends HTMLElement {
  get details() {
    const e = this.querySelector("details");
    if (!(e instanceof HTMLDetailsElement))
      throw new Error("Details element not found");
    return e;
  }

  get summary() {
    const e = this.details.querySelector("summary");
    if (!(e instanceof HTMLElement))
      throw new Error("Summary element not found");
    return e;
  }

  get #e() {
    return "true" === this.dataset.disableOnMobile;
  }

  get #t() {
    return "true" === this.dataset.disableOnDesktop;
  }

  get #i() {
    return "true" === this.dataset.closeWithEscape;
  }

  #s = new AbortController();

  connectedCallback() {
    const { signal: e } = this.#s;
    this.#n();
    this.addEventListener("keydown", this.#o, { signal: e });
    this.summary.addEventListener("click", this.handleClick, { signal: e });
    mediaQueryLarge.addEventListener("change", this.#a, { signal: e });
  }

  disconnectedCallback() {
    this.#s.abort();
  }

  handleClick = e => {
    const t = isMobileBreakpoint();
    const i = !t;
    (t && this.#e || i && this.#t) && e.preventDefault();
  };

  #a = () => {
    this.#n();
  };

  #n() {
    const e = isMobileBreakpoint();
    this.details.open =
      (e && this.hasAttribute("open-by-default-on-mobile")) ||
      (!e && this.hasAttribute("open-by-default-on-desktop"));
  }

  #o = e => {
    if ("Escape" === e.key && this.#i) {
      e.preventDefault();
      this.details.open = false;
      this.summary.focus();
    }
  };
}

customElements.get("accordion-custom") ||
  customElements.define("accordion-custom", AccordionCustom);
